import React from 'react';
import { connect, useSelector } from 'react-redux';
import { Field, reduxForm, getFormValues } from 'redux-form';
import { get } from 'lodash';
import { Form, Col, Row, ControlLabel, FormGroup } from 'react-bootstrap';
import { required } from 'redux-form-validators';
import { SelectField } from '../../../../common/components/ReduxFormField';
import {
  Box,
  Button,
  ButtonBar,
  DatePicker,
  SelectInsurer,
} from '../../../../common/components';
import { generateReport } from '../../redux/accountActions';
import { isOwner } from '../../../auth/redux/authActions';
import { FullRow } from '../../../layout/components';
import CheckboxUnlabeled from '../../../../common/components/ReduxFormField/CheckboxUnlabeled';
import { getReports } from '../../helpers';
import './styles.scss';
import { differenceInDays, parseISO } from 'date-fns';

const isRequired = required({ message: 'Required' });

const SCHEME_TYPES = [
  { label: 'Annual', value: 'annual' },
  { label: 'Single', value: 'single' },
];

const queueValidator = (value, option, { formValues }) => {

  const fromDate = formValues?.from_date ? parseISO(formValues.from_date) : undefined;
  const toDate = formValues?.to_date ? parseISO(formValues.to_date) : undefined;
  const diff  =  differenceInDays( toDate, fromDate);
  if (!value && diff > 2) {
    return 'Please run reports greater than 3 days on the queue';
  }

};
const BordereauxReports = ({
  dispatch,
  change,
  formValues,
  handleSubmit,
  onGenerateReport,
}) => {
  const { isGeneratingReport } = useSelector((state) => state.account);

  const handleReportChange = (reportOption) => {
    if (reportOption.value === 'broker_report:bespoke') {
      dispatch(change('from_date', ''));
      dispatch(change('to_date', ''));
    } else {
      dispatch(change('month', ''));
    }

    if (
      [
        'aig_pa_master:bespoke',
        'aig_pa_individual:bespoke',
        'aig_pa_tag_along:bespoke',
      ].includes(reportOption.value)
    ) {
      dispatch(change('scheme_type', ''));
      dispatch(change('insurer', 'AIGPA'));
    }
  };

  const generate = (values) => {
    onGenerateReport(values);
  };

  const report = formValues ? formValues.report : undefined;
  const reports = getReports();

  return (
    <Box>
      <Form onSubmit={handleSubmit(generate)}>
        <Row>
          <Col sm={12}>
            <h2 className="resource-name">Reports</h2>
          </Col>
        </Row>
        <Field
          name="report"
          label="Report"
          labelSize={2}
          smFieldSize={4}
          component={SelectField}
          handleOnChange={handleReportChange}
          options={reports}
          validate={[isRequired]}
        />

        {isOwner() &&
          [
            'aig_pa_master:bespoke',
            'aig_pa_individual:bespoke',
            'aig_pa_tag_along:bespoke',
          ].includes(get(formValues, 'report')) && (
            <Field
              name="output"
              label="Output Format"
              labelSize={2}
              smFieldSize={4}
              component={SelectField}
              options={[
                { value: 'csv', label: 'Standard' },
                { value: 'txt', label: 'AIG' },
              ]}
            />
          )}

        {isOwner && !['duplicate_customers:bespoke'].includes(report) && (
          <>
            <Field
              name="insurer"
              label="Brand"
              labelSize={2}
              smFieldSize={4}
              component={SelectInsurer}
            />

            <Field
              name="scheme_type"
              label="Scheme Type"
              labelSize={2}
              smFieldSize={4}
              component={SelectField}
              isClearable
              options={SCHEME_TYPES}
            />
          </>
        )}

        {['broker_report:bespoke'].includes(report) && (
          <FormGroup>
            <Col sm={2}>
              <ControlLabel>Select Month</ControlLabel>
            </Col>
            <Col sm={4}>
              <div className={'date-group'}>
                <Field
                  name="month"
                  component={DatePicker}
                  dateFormat={'MM/yyyy'}
                  validate={[isRequired]}
                  showMonthYearPicker
                />
              </div>
            </Col>
          </FormGroup>
        )}

        {['active_policies:bespoke'].includes(report) && (
          <FormGroup>
            <Col sm={2}>
              <ControlLabel>Select Month</ControlLabel>
            </Col>
            <Col sm={4}>
              <div className={'date-group'}>
                <Field name="from_date" component={DatePicker} validate={[isRequired]} />
              </div>
            </Col>
          </FormGroup>
        )}
        {![
          'broker_report:bespoke',
          'active_policies:bespoke',
          'duplicate_customers:bespoke',
        ].includes(report) && (
          <FormGroup>
            <Col sm={2}>
              <ControlLabel>From Date</ControlLabel>
            </Col>
            <Col sm={4}>
              <div className={'date-group'}>
                <Field name="from_date" component={DatePicker} validate={[isRequired]} />

                <span className={'to-label'}>to</span>
                <Field
                  name="to_date"
                  minDate={get(formValues, 'from_date')}
                  component={DatePicker}
                  validate={[isRequired]}
                />
              </div>
            </Col>
          </FormGroup>
        )}
        <FullRow>
          <Field
            name={'generator'}
            label={'Queue'}
            options={[{ value: true, name: 'generator' }]}
            validate={queueValidator}
            showError={true}
            component={CheckboxUnlabeled}
          />
        </FullRow>
        <Row>
          <Col sm={12}>
            <ButtonBar>
              <Button
                className="pull-right"
                type="submit"
                label="Generate Report"
                isLoading={isGeneratingReport}
                bsStyle="primary"
              />
            </ButtonBar>
          </Col>
        </Row>
      </Form>
    </Box>
  );
};

const FORM_NAME = 'BordereauxReportsForm';

const form = reduxForm({ form: FORM_NAME })(BordereauxReports);

export default connect(
  (state) => ({
    formValues: getFormValues(FORM_NAME)(state),
  }),
  {
    onGenerateReport: generateReport,
  },
)(form);
